// ─── Jetons : appels SERVEUR (Core) ───────────────────────────────
// Toutes les écritures passent par des Cloud Functions : les règles Firestore
// refusent au client d'écrire `jetonsSelection` / `jetonsDons` / la dotation.
// Sans cela, il suffirait de s'attribuer cinquante éléments.
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const appeler = (nom) => (data) => httpsCallable(functions, nom)(data || {}).then(r => r.data);

// selection : [{ cle, nature }] ORDONNÉE — l'index est la priorité.
export const choisirElements = (selection) => appeler('choisirElements')({ selection });
// nature : 'gestion' (⚙️) ou 'vue' (👁) — offrir la lecture coûte un jeton 👁.
export const confierElement = (cle, uid, nature) => appeler('confierElement')({ cle, uid, nature });
export const reprendreElement = (cle, uid) => appeler('reprendreElement')({ cle, uid });
export const mesElementsConfies = () => appeler('mesElementsConfies')();
// Déplacer (mon espace) ou DONNER (espace d'autrui : la propriété change et mes
// offres sur cet élément tombent) — le serveur tranche selon l'espace cible.
export const transfererElement = (cle, espaceId) => appeler('transfererElement')({ cle, espaceId });

// Message d'erreur lisible : les callables remontent un code + un message.
export const messageJetons = (e) => e?.message || String(e || '');
